<div class="parallax" id="theory">
    <div class="container">
        <h1>Making sense of production systems with Lean Manufacturing</h1>
        <h3>Read about the methods we use:</h3>
    </div>
</div>

<style>
    .parallax {
        background-image: url("https://images.unsplash.com/photo-1475694867812-f82b8696d610?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2089&q=80");
        background-repeat: no-repeat;
        background-attachment: fixed;
        background-position: center;
        color: white;
        z-index: 1;
        height: 250px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;

        align-items: center;
    }
    @media screen and (max-width: 900px) {
        .parallax {
            height: 175px;
        }

        h1 {
            font-size: 1.25em !important;
        }
        h3 {
            font-size: 1em !important;
        }
    }
</style>
